import React, { FC } from "react";
import { UseFormRegister, FieldError } from "react-hook-form";
import FormModal from "@/components/modals/FormModal";
import { avoidEmptyStringValidator, FormHookInput } from "@thdinc/hpf-shared";
import { PackageForm } from "../types/priceCalculation.types";

interface EditPackageModalProps {
    isOpen: boolean;
    onClose: () => void;
    register: UseFormRegister<PackageForm>;
    packageNameError?: FieldError;
    onSubmit: () => void;
}

const EditPackageModal: FC<EditPackageModalProps> = ({
    isOpen,
    onClose,
    register,
    packageNameError,
    onSubmit,
}) => {
    return (
        <FormModal
            overflow="overflow-hidden "
            modalTitle={"Edit Package"}
            isOpen={isOpen}
            width="lg:w-3/6 md:w-5/6 w-full "
            height="overflow-y-auto "
            onClose={onClose}
            footer={
                <div className="flex justify-end">
                    <p
                        className="text-sm text-white rounded-full px-5 py-2 bg-primary-red cursor-pointer"
                        onClick={onSubmit}
                    >
                        {"Update"}
                    </p>
                </div>
            }
        >
            <div className="container mx-auto p-4">
                <div className="grid grid-cols-1 gap-8">
                    <div className="w-full ">
                        <div className=" font-semibold mb-2">Package Name *</div>
                        <FormHookInput
                            updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                            type="text"
                            maxLength={100}
                            placeholder="Package Name"
                            register={register("packageName", {
                                maxLength: {
                                    value: 100,
                                    message: "Package Name can't be more than 100 characters.",
                                },
                                pattern: avoidEmptyStringValidator,
                                required: "Package Name is required",
                            })}
                            error={packageNameError}
                        />
                    </div>
                </div>
            </div>
        </FormModal>
    );
};

export default EditPackageModal;
